import { IntlFormatters } from "react-intl";
import defineMessages from "./defineMessages";
import { INote, ISignature } from "../types";
import { ISettings } from "../types/score/settings";

const upperTextMessages = defineMessages({
    empty: {
        id: "score.upperText.empty",
    },
    solfa: {
        id: "score.upperText.solfa",
    },
    rhythm: {
        id: "score.upperText.rhythm",
    },
    abc: {
        id: "score.upperText.abc",
    },
});

export const upperTextOptions = (fm: IntlFormatters["formatMessage"]): { value: ISettings["upperText"], label: string }[] => [
    {
        value: 0,
        label: fm(upperTextMessages.empty),
    },
    {
        value: 1,
        label: fm(upperTextMessages.solfa),
    },
    {
        value: 2,
        label: fm(upperTextMessages.rhythm),
    },
    {
        value: 3,
        label: fm(upperTextMessages.abc),
    },
];

const numberOfLinesMessages = defineMessages({
    n2: {
        id: "score.numberOfLines.2",
    },
    n3: {
        id: "score.numberOfLines.3",
    },
    n4: {
        id: "score.numberOfLines.4",
    },
    n5: {
        id: "score.numberOfLines.5",
    },
});

export const numberOfLinesOptions = (fm: IntlFormatters["formatMessage"]): { value: NonNullable<ISettings["lines"]>, label: string }[] => [
    {
        value: 2,
        label: fm(numberOfLinesMessages.n2),
    },
    {
        value: 3,
        label: fm(numberOfLinesMessages.n3),
    },
    {
        value: 4,
        label: fm(numberOfLinesMessages.n4),
    },
    {
        value: 5,
        label: fm(numberOfLinesMessages.n5),
    },
];

const noteheadValues: NonNullable<ISettings["notehead"]>[] = ["normal", "solfa", "number", "handsign"];

export const noteheadOptions = (fm: IntlFormatters["formatMessage"]) =>
    noteheadValues.map(value => ({
        value,
        label: fm(
            defineMessages({
                message: {
                    id: `score.settings.notehead.options.${value}`,
                },
            }).message
        ),
    }));




const getNotesLength = (notes: INote[]) => {
    return (
        notes.reduce((total, note) => {
            const noteLength = (4 / note.l) * (note.d ? 1.5 : 1) * (note.t ? 2 : 3);
            return total + noteLength;
        }, 0) / 3
    );
};

const getBarLength = (signature: ISignature) => {
    return signature.num * (4 / signature.den);
};

export const getShowGhostBarline = (signature: ISignature, notes: INote[]) => {
    if (!signature.upbeat) return false;
    if (signature.upbeat + getNotesLength(notes) === getBarLength(signature)) {
        return true;
    }
    return false;
};
